import { Modal } from './Modal';

function ReviewRow({ label, value, accent, wide }) {
  return (
    <div className={wide ? 'review-row review-row-full' : 'review-row'}>
      <span className="review-label">{label}</span>
      <span className={`review-value${accent ? ` is-${accent}` : ''}`}>{value || '—'}</span>
    </div>
  );
}

export function ReviewModal({
  actionType,
  formData,
  errors,
  isOnline,
  onBack,
  onConfirm,
}) {
  const isCheckout = actionType === 'checkout';

  return (
    <Modal onClose={onBack}>
      <h2 className="modal-title">
        Review & Confirm {isCheckout ? 'Check Out' : 'Check In'}
      </h2>

      {errors.length > 0 && (
        <div className="error-box">
          <strong>Please fix the following:</strong>
          <ul>
            {errors.map((error) => (
              <li key={error}>{error}</li>
            ))}
          </ul>
        </div>
      )}

      <div className="review-grid">
        <ReviewRow label="Asset Tag" value={formData.asset_tag} />
        <ReviewRow label="Brand & Model" value={formData.brand_model} />
        <ReviewRow label="Serial Number" value={formData.serial_number} />
        <ReviewRow label="Project Number" value={formData.project_number} />
        <ReviewRow label="Equipment Type" value={formData.equipment_type} />
        <ReviewRow label="Condition" value={formData.condition} />
        <ReviewRow label="Country" value={formData.country} />
        <ReviewRow label="Assignee" value={formData.assignee_email} />
        <ReviewRow label="Status" value={isCheckout ? 'Active' : 'Returned'} />
        <ReviewRow
          label="Action"
          value={isCheckout ? '📤 Checking Out Asset' : '📥 Checking In Asset'}
          accent={isCheckout ? 'checkout' : 'checkin'}
          wide
        />
      </div>

      <div className="modal-actions">
        <button type="button" className="btn btn-secondary" onClick={onBack}>
          Back
        </button>
        <button
          type="button"
          className="btn btn-primary"
          onClick={onConfirm}
          disabled={errors.length > 0 || !isOnline}
        >
          Confirm & Submit
        </button>
      </div>
    </Modal>
  );
}
